const PN1 = [
    { id: "0", value: "正" },
    { id: "1", value: "負" },
];

export default PN1